import type { SVGProps } from "react";

import { cn } from "@/lib/utils";

type InfoIconProps = SVGProps<SVGSVGElement>;

export function InfoIcon({ className, ...props }: InfoIconProps) {
  return (
    <svg
      viewBox="0 0 20 20"
      className={cn("size-5", className)}
      fill="none"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M109 3.33301C112.682 3.33301 115.667 6.3181 115.667 10C115.667 13.6819 112.682 16.667 109 16.667C105.318 16.667 102.333 13.6819 102.333 10C102.333 6.3181 105.318 3.33301 109 3.33301ZM107.133 9.1582H108.637V12.2295H107.133V13.333H111.439V12.2295H110.009V8.0498H107.133V9.1582ZM109.32 5.97461C109.203 5.97464 109.096 5.99255 108.998 6.02832C108.904 6.06412 108.822 6.11299 108.754 6.1748C108.686 6.23987 108.632 6.3181 108.593 6.40918C108.557 6.49698 108.539 6.59322 108.539 6.69727C108.539 6.80128 108.557 6.8992 108.593 6.99023C108.632 7.07798 108.686 7.15305 108.754 7.21484C108.822 7.27986 108.904 7.33041 108.998 7.36621C109.096 7.40199 109.203 7.41989 109.32 7.41992C109.561 7.41992 109.752 7.35319 109.892 7.21973C110.035 7.08301 110.106 6.90885 110.106 6.69727C110.106 6.48583 110.035 6.31308 109.892 6.17969C109.752 6.04318 109.561 5.97461 109.32 5.97461Z"
        fill="currentColor"
        transform="translate(-99 0)"
      />
    </svg>
  );
}
